import PropTypes from 'prop-types'
import classnames from 'classnames'

import classes from './CheckBox.module.scss'

const CheckBox = ({ id, label, isSelected, onClick, size = 'md' }) => (
  <label htmlFor={id} className={classnames(classes.wrapper, classes[size])}>
    <input
      id={id}
      type='checkbox'
      className={classes.hiddenInput}
      checked={isSelected}
      onChange={onClick}
    />
    <span className={classnames(classes.checkbox, { [classes.checked]: isSelected })}>
      {isSelected && <i className='fa fa-check' aria-hidden='true' />}
    </span>
    <span className={classes.label}>{label}</span>
  </label>
)

CheckBox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
}

export default CheckBox
